export const MATERIAL_REPORT_PAGE_SIZE = 25;

export const REPORT_COLUMNS = {
  layers: [
    'source_kind',
    'fifo_at',
    'original_quantity',
    'remaining_quantity',
    'unit_cost_ars',
    'original_value_ars',
    'historical_amount_ars',
    'current_amount_ars',
    'valuation_notes',
  ],
  lines: [
    'order_number',
    'project_name',
    'article_code',
    'article_name',
    'group_name',
    'unit',
    'state',
    'requested_quantity',
    'reserved_quantity',
    'pending_quantity',
    'received_quantity',
    'consumed_quantity',
    'delivered_quantity',
    'returned_quantity',
    'delivered_quantity_net',
    'requested_amount',
    'reserved_amount',
    'pending_amount',
    'delivered_amount_gross',
    'returned_amount',
    'delivered_amount',
    'next_delivery',
  ],
  projects: [
    'name',
    'line_count',
    'requested_amount',
    'reserved_amount',
    'pending_amount',
    'delivered_amount_gross',
    'returned_amount',
    'delivered_amount',
    'consumed_amount',
    'unvalued_lines',
  ],
  articles: [
    'name',
    'unit',
    'requested_quantity',
    'representative_unit_cost',
    'reserved_quantity',
    'pending_quantity',
    'received_quantity',
    'delivered_quantity',
    'returned_quantity',
    'delivered_quantity_net',
    'requested_amount',
    'reserved_amount',
    'pending_amount',
    'delivered_amount_gross',
    'returned_amount',
    'delivered_amount',
  ],
  providers: [
    'name',
    'purchased_amount',
    'order_count',
    'line_count',
    'pending_amount',
    'overdue_count',
    'late_count',
    'on_time_percentage',
    'average_delay',
    'unknown_commitment_count',
  ],
  purchases: [
    'order_code',
    'project_name',
    'article_name',
    'provider_name',
    'requested_quantity',
    'received_quantity',
    'pending_quantity',
    'commitment_at',
    'completion_at',
    'deviation_days',
    'days_overdue',
    'pending_amount',
    'historical_amount_ars',
    'current_amount_ars',
  ],
  inventory: [
    'article_name',
    'physical_quantity',
    'reserved_quantity',
    'free_quantity',
    'reserved_amount',
    'free_amount',
    'valued_quantity',
    'unvalued_quantity',
    'historical_amount_ars',
    'current_amount_ars',
  ],
};

export const TEXT_COLUMNS = [
  'source_kind',
  'fifo_at',
  'valuation_notes',
  'name',
  'order_number',
  'order_code',
  'project_name',
  'article_code',
  'article_name',
  'group_name',
  'unit',
  'state',
  'provider_name',
  'commitment_at',
  'completion_at',
  'next_delivery',
];

/** Columnas de fecha: se alinean como texto y se filtran por día. */
export const DATE_COLUMNS = ['fifo_at', 'commitment_at', 'completion_at', 'next_delivery'];

/** Ancho fijo por columna, para que filtrar u ordenar no mueva la tabla. */
export const EXPAND_COLUMN_WIDTH = 52;
export const DEFAULT_TEXT_COLUMN_WIDTH = 150;
export const DEFAULT_NUMBER_COLUMN_WIDTH = 140;
export const COLUMN_WIDTHS = {
  name: 260,
  article_name: 260,
  project_name: 220,
  provider_name: 220,
  valuation_notes: 260,
  group_name: 180,
  source_kind: 190,
  order_number: 110,
  order_code: 150,
  article_code: 120,
  unit: 110,
  state: 170,
  fifo_at: 130,
  commitment_at: 130,
  completion_at: 130,
  next_delivery: 140,
};

export const COLUMN_LABELS = {
  returned_quantity: 'Devuelto',
  delivered_quantity_net: 'Entregado neto',
  consumed_quantity_net: 'Salido neto',
  returned_amount: 'Costo devuelto',
  delivered_amount_gross: 'Costo entregado bruto',
  consumed_amount_gross: 'Costo salida bruta',
  received_amount: 'Costo recibido',
  free_amount: 'Costo libre',
  source_kind: 'Origen',
  fifo_at: 'Ingreso FIFO',
  original_quantity: 'Cantidad inicial',
  remaining_quantity: 'Remanente',
  unit_cost_ars: 'Costo original unitario',
  original_value_ars: 'Valor original',
  valuation_notes: 'Fuente / estimación',
  name: 'Nombre',
  order_number: 'PT',
  order_code: 'PP',
  project_name: 'Vivienda',
  article_code: 'Código',
  article_name: 'Material',
  group_name: 'Grupo',
  unit: 'Unidad',
  state: 'Etapa',
  line_count: 'Renglones',
  requested_quantity: 'Pedido',
  reserved_quantity: 'Reservado',
  pending_quantity: 'Por llegar',
  received_quantity: 'Recibido',
  consumed_quantity: 'Salido',
  delivered_quantity: 'Entregado',
  unvalued_lines: 'Sin valorar',
  requested_amount: 'Costo pedido',
  reserved_amount: 'Costo reservado',
  pending_amount: 'Costo por llegar',
  delivered_amount: 'Costo entregado neto',
  consumed_amount: 'Costo salida neta',
  representative_unit_cost: 'Unitario representativo',
  purchase_amount: 'Comprado',
  purchased_amount: 'Comprado',
  provider_name: 'Proveedor',
  order_count: 'PP distintas',
  overdue_count: 'Pendientes vencidos',
  late_count: 'Completados tarde',
  on_time_percentage: '% a tiempo',
  average_delay: 'Desvío promedio (días)',
  unknown_commitment_count: 'Sin compromiso',
  commitment_at: 'Compromiso',
  completion_at: 'Recepción completa',
  deviation_days: 'Desvío (días)',
  days_overdue: 'Días vencidos',
  physical_quantity: 'Físico global',
  free_quantity: 'Libre global',
  valued_quantity: 'Valorizado',
  unvalued_quantity: 'Sin valorizar',
  historical_amount_ars: 'Pesos originales',
  current_amount_ars: 'Equivalente actualizado',
  next_delivery: 'Próxima entrega',
};

export const MATERIAL_TABLE_TEXTS = {
  empty: 'No hay materiales para estos filtros.',
  noArticles: 'Sin artículos',
  total: 'Total filtrado',
  expand: 'Ver compras, recepciones y remitos',
  collapse: 'Ocultar detalle',
  transfer: 'Traslado entre depósitos',
  original: 'Original',
  current: 'Actualizado',
  receipt: 'Recepción',
  acceptedQuantity: 'Cantidad aceptada',
  document: 'Remito',
  noDocument: 'Sin remito informado',
  noReceipts: 'Sin recepciones registradas.',
};

export const SOURCE_KIND_LABELS = {
  work_return: 'Devolución de obra',
  opening: 'Apertura estimada',
  provider_receipt: 'Recepción de proveedor',
  warehouse_receipt: 'Traslado entre depósitos',
  adjustment_in: 'Ajuste de ingreso',
};

export const STATE_LABELS = {
  delivered: 'Entregado a obra',
  pending_delivery: 'Salida pendiente de entrega',
  in_warehouse: 'En depósito',
  incoming: 'Por llegar',
  partially_received: 'Recibido parcialmente',
  unfulfilled: 'Sin abastecer',
};

export const MATERIAL_QUANTITY_TABLE_TEXTS = {
  material: 'Material',
  unit: 'Unidad',
  quantity: 'Cantidad',
  actions: 'Acciones',
  remove: 'Quitar',
  empty: 'Agregá al menos un material.',
};
